export const url = "https://fakestoreapi.com" || process.env.storeUrl;
